/* Locations */
export const COUNTRIES = `location/countries-only`; // #!DONE
export const REGIONS_IN_COUNTRY = `location/regions_in_a_country/160`;
export const CITIES_IN_REGION = `location/cities_in_a_region/`;
export const COUNTRIES_WITH_REGIONS = `location/countries`;

export const REGIONS_ONLY = `location/regions-only`;
export const ALL_COUNTRIES = `location/countries`; //#DONE
export const ALL_USERS = `admin/users/all`; //#DONE
export const SEARCH_USERS = `admin/users/search`; //#DONE
export const SEARCH_PROJECTS = `project/search`; //#DONE
export const SEARCH_PROJECTS_ACTION = `admin/project/search-projects`; //#DONE
export const REGION_DETAILS = `location/region-detail/`; //#DONE
export const CITY_DETAILS = `location/city-detail/`; //#DONE

//Ask Blessing(Seyi)
export const GET_REGION_WITH_COUNTRY_ID = {
    COUNTRY_ID: (id) => `location/regions_in_a_country/${id}`,  // #DONE
};
export const GET_CITIES_WITH_REGION_ID = {
    REGION_ID: (id) => `location/cities_in_a_region/${id}`,
};
